import { createSelector } from "reselect";

const selectMap = (state) => state.map;

export const selectMapLevel = createSelector(selectMap, (map) => map.level);

export const selectMapCenterOfMapAddress = createSelector(
  selectMap,
  (map) => map.centerOfMapAddress
);

export const selectCenterOfMapAddressIsLoading = createSelector(
  selectMap,
  (map) => map.centerOfMapAddressIsLoading
);

export const selectMapLeftOverlayShow = createSelector(
  selectMap,
  (map) => map.mapLeftOverlayShow
);

export const selectCenterOfMap = createSelector(
  selectMap,
  (map) => map.centerOfMap
);

export const selectMapSuggestions = createSelector(
  selectMap,
  (map) => map.suggestions
);
export const selectMapSuggestionsIsLoading = createSelector(
  selectMap,
  (map) => map.suggestionsIsLoading
);
export const selectMapSuggestionsShow = createSelector(
  selectMap,
  (map) => map.suggestions_show
);

export const selectMapBottomWhiteLong = createSelector(
  selectMap,
  (map) => map.bottomWhite_long
);

export const selectMapGoLevel4 = createSelector(
  selectMap,
  (map) => map.goLevel_4
);

export const selectMapSourceLoacationJustSet = createSelector(
  selectMap,
  (map) => map.sourceLoaction_justSet
);
